import '../css/theraskin-modal.css';

document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("theraskin-modal-product");
  if (!modal) return;

  modal.addEventListener("show.bs.modal", function () {
    injectHidden();
  });

  modal.addEventListener("hidden.bs.modal", function () {
    resetForm();
  });

  function injectHidden() {
    const product = modal.dataset.product;
    const category = modal.dataset.category;
    const url = modal.dataset.url;
    const form = modal.querySelector(".wpcf7 form");

    if (!form) return;

    const fProduct = form.querySelector("input[name='lead-product']");
    if (fProduct) fProduct.value = product;

    const fCategory = form.querySelector("input[name='lead-product-category']");
    if (fCategory) fCategory.value = category;

    const fUrl = form.querySelector("input[name='lead-product-url']");
    if (fUrl) fUrl.value = url;

    const fReferrer = form.querySelector("input[name='lead-referrer']");
    if (fReferrer) fReferrer.value = document.referrer || window.location.href;

    const fUserAgent = form.querySelector("input[name='lead-user-agent']");
    if (fUserAgent) fUserAgent.value = navigator.userAgent;
  }

  function resetForm() {
    const form = modal.querySelector(".wpcf7 form");
    if (!form) return;

    form.reset();

    const wrapper = modal.querySelector(".wpcf7");
    if (wrapper) {
      wrapper.classList.remove(
        "sent",
        "invalid",
        "failed",
        "spam",
        "aborted"
      );

      const response = wrapper.querySelector(".wpcf7-response-output");

      if (response) {
        response.innerHTML = "";
      }
    }
  }
});

document.addEventListener('wpcf7submit', function(event) {
  if(event.detail.status !== 'mail_sent' && event.detail.status !== 'success') {
    return false;
  }

  if (typeof gtag !== 'function') {
    console.warn('gtag não está definido. Conversão não disparada.');
    return false;
  }

  const form = event.target;
  const categoryField = form.querySelector("input[name='lead-product-category']");
  const productField = form.querySelector("input[name='lead-product']");

  if (!categoryField || !productField) {
    return false;
  }

  const categoryValue = categoryField.value || '';
  const productValue = productField.value || '';
  const labelValue = (categoryValue && productValue) 
    ? categoryValue + ' - ' + productValue 
    : `Formulário ${event.detail.contactFormId}`;

  gtag('event', 'conversion', {
    'send_to': 'AW-657382628/general_leads',
    'form_id': event.detail.contactFormId,
    'form_name': labelValue
  });

  gtag('event', 'generate_lead', {
    event_category: 'Formulário',
    event_label: labelValue
  });

  console.log("Lead capturado:", labelValue);
}, false);
